import { FC } from "react";
import { AdminToolsGridContainer } from "./admin-tools-grid.styled";
import { MergeAccountsGridItem } from "./subcomponents/merge-accounts-grid-item/merge-accounts-grid-item";

export const AdminToolsGrid: FC = () => {
    return (
        <AdminToolsGridContainer>
            <MergeAccountsGridItem />
        </AdminToolsGridContainer>
    )
}